import { decodeFA } from "../utils/decodeFA.js";

const UnderConstruction = ({ message }: { message?: string }) => {
  return (
    <div className="flex flex-col py-4 justify-center">
      <div className="flex  gap-x-6">
        <i
          className={`size-6 mt-2  fa-regular ${decodeFA(
            `screwdriver-wrench`
          )}`}
        />
        <div>
          <h1 className="text-xl font-bold">Under Construction</h1>
          <p className="text">
            {message || "This page is under construction."}
          </p>
        </div>
      </div>
    </div>
  );
};

export default UnderConstruction;
